/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ToggleableFeature,
    ToggleableFeatureFromJSON,
    ToggleableFeatureFromJSONTyped,
    ToggleableFeatureToJSON,
} from './';

/**
 * 
 * @export
 * @interface ToggleFeatureRequest
 */
export interface ToggleFeatureRequest {
    /**
     * 
     * @type {ToggleableFeature}
     * @memberof ToggleFeatureRequest
     */
    feature: ToggleableFeature;
    /**
     * 
     * @type {boolean}
     * @memberof ToggleFeatureRequest
     */
    isDisabled: boolean;
}

export function ToggleFeatureRequestFromJSON(json: any): ToggleFeatureRequest {
    return ToggleFeatureRequestFromJSONTyped(json, false);
}

export function ToggleFeatureRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ToggleFeatureRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'feature': ToggleableFeatureFromJSON(json['feature']),
        'isDisabled': json['isDisabled'],
    };
}

export function ToggleFeatureRequestToJSON(value?: ToggleFeatureRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'feature': ToggleableFeatureToJSON(value.feature),
        'isDisabled': value.isDisabled,
    };
}


